import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for PWG5M1 (繳款單核准沖銷)
// ============================================================

export interface ReverseCandidate {
  fg110_01: string; // 繳款單號
  fg110_11: string; // 繳款日期
  fg110_12: string; // 台幣繳款金額
  fg110_13: string; // 外幣繳款金額
  fg110_17: string; // 繳款類型
  fg110_18: string; // 核准狀態
  fg110_19: string; // 部門名稱
  fg110_24: string; // 水單匯率
  fg110_26: string; // 廠商代號
}

export interface QueryResponse {
  items: ReverseCandidate[];
  total: number;
}

export interface ReverseResponse {
  success: number;
  failed: number;
  errors?: string[];
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const pwg5m1Api = {
  /** Query payment slip candidates eligible for reversal */
  async queryCandidates(startNo: string, endNo: string): Promise<QueryResponse> {
    const params: Record<string, string> = {};
    if (startNo.trim()) params['start'] = startNo.trim();
    if (endNo.trim()) params['end'] = endNo.trim();
    const res = await apiClient.get('/api/pwg5m1/candidates', { params });
    return res.data;
  },

  /**
   * Execute batch reversal for selected payment slips.
   * PWG5M1-VAL-REVERSE-CONFIRM-DIALOG (human_approved 2026-07-23): backend
   * now rejects any call missing an explicit confirmed:true with 422 + zero
   * DB mutation. Callers must only invoke this after the user has confirmed
   * (e.g. inside a Modal.confirm's onOk), same as pwh508f1/pwh5m8f1/pwg5m4f1's
   * own frontend API clients.
   */
  async reverse(items: string[], confirmed: boolean = true): Promise<ReverseResponse> {
    const res = await apiClient.post('/api/pwg5m1/reverse', { items, confirmed });
    return res.data;
  },
};
